import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import { clientApi } from '@/api/client'
import Topbar from '@/components/Topbar'
import ErrorBox from '@/components/ErrorBox'
import Skeleton from '@/components/Skeleton'

export default function OrgSetup() {
  const nav = useNavigate()
  const [org, setOrg] = useState<any | null>(null)
  const [name, setName] = useState('')
  const [slug, setSlug] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<any>(null)

  useEffect(() => {
    let cancelled = false
    clientApi.org().then((res) => {
      if (cancelled) return
      const o = res?.org
      setOrg(o)
      setName(String(o?.name || ''))
      setSlug(String(o?.slug || ''))
    }).catch(setError)
    return () => { cancelled = true }
  }, [])

  async function save() {
    setBusy(true)
    setError(null)
    try {
      const r = await clientApi.updateOrg(name || null, slug || null)
      setOrg(r?.org || null)
      nav('/dashboard')
    } catch (e) {
      setError(e)
    } finally {
      setBusy(false)
    }
  }

  if (!org && !error) {
    return (
      <div className="container">
        <Topbar subtitle="Organization" />
        <div className="grid" style={{ marginTop: 16 }}>
          <Skeleton variant="card" count={2} />
        </div>
      </div>
    )
  }

  return (
    <div className="container">
      <Topbar subtitle="Organization" />

      <div className="grid">
        <div className="card">
          <h2>Organization details</h2>
          <div className="muted" style={{ marginTop: 6 }}>
            Set your organization name and slug.
          </div>
          <div style={{ height: 12 }} />

          <div className="stack">
            <div>
              <div className="muted" style={{ fontSize: 12 }}>Name</div>
              <div style={{ height: 6 }} />
              <input className="input" value={name} onChange={(e) => setName(e.target.value)} placeholder="Acme Capital" />
            </div>

            <div>
              <div className="muted" style={{ fontSize: 12 }}>Slug</div>
              <div style={{ height: 6 }} />
              <input className="input mono" value={slug} onChange={(e) => setSlug(e.target.value)} placeholder="acme-capital" />
            </div>
          </div>

          <div style={{ height: 14 }} />
          <div className="row">
            <button className="btn primary" onClick={save} disabled={busy || !name.trim()}>
              Save
            </button>
            <button className="btn" onClick={() => nav('/dashboard')} disabled={busy}>
              Skip
            </button>
          </div>
        </div>

        {error ? <ErrorBox error={error} /> : null}
      </div>
    </div>
  )
}
